import { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { RegisterForm } from '../components/auth/RegisterForm';
import { usePageTitle } from '../hooks/usePageTitle';
import { configApi } from '../api/configApi';

export function RegisterPage() {
  usePageTitle('Register — Hawkes Bridge');
  const [underConstruction, setUnderConstruction] = useState<boolean | null>(null);
  const configFetched = useRef(false);

  useEffect(() => {
    if (configFetched.current) return;
    configFetched.current = true;
    configApi.getClientConfig().then(cfg => {
      setUnderConstruction(cfg.siteUnderConstruction);
    }).catch(() => {
      setUnderConstruction(false);
    });
  }, []);

  if (underConstruction === null) {
    return null;
  }

  if (underConstruction) {
    return (
      <div className="min-h-[80vh] flex items-center justify-center px-4 py-12">
        <div className="w-full max-w-md">
          <div className="bg-card rounded-xl shadow-sm p-8 text-center">
            <div className="mx-auto w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center mb-6">
              <svg
                className="w-8 h-8 text-yellow-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                aria-hidden="true"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4.5c-.77-.833-2.694-.833-3.464 0L3.34 16.5c-.77.833.192 2.5 1.732 2.5z"
                />
              </svg>
            </div>
            <h1 className="text-2xl font-bold text-ink mb-4">
              Registration Unavailable
            </h1>
            <p className="text-ink-soft mb-8">
              This website is currently under construction. Account registration is not available at this time.
            </p>
            <Link
              to="/"
              className="btn-primary inline-block text-base px-6 py-2"
            >
              Back to Home
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md">
        <div className="bg-card rounded-xl shadow-sm p-8">
          <h1 className="text-2xl font-bold text-center text-ink mb-6">
            Create Your Account
          </h1>
          <p className="text-center text-ink-soft mb-8">
            Join Hawkes Bridge and start improving your bidding skills today.
          </p>
          <RegisterForm />
        </div>
      </div>
    </div>
  );
}
